import morpheusApi from '@/state/morpheus/morpheus.slice'

export interface OnboardingSetupSignal {
  /**
   * Does the sidebar carry the row. Decided by morpheus's delivery
   * model and passed straight through, never re-derived here.
   *
   * Not the outstanding count, which was the first attempt and was
   * wrong: a job that completed an hour ago has nothing polled against
   * it yet, so nothing is "outstanding" while the list is very much
   * unfinished. That hid the row from the customer who signed up this
   * morning, who then could not reach the page that does the first
   * poll, because the way to the page is the row.
   */
  nav: boolean
  /** For the badge. Zero while nothing has been polled, which is honest. */
  outstanding: number
}

/**
 * This organisation's setup state, for the nav.
 *
 * THE ONE HOOK, called from both nav context builders (`useNavCtx` for
 * the old UI, the new sidebar shell for the new) and nowhere else. A
 * second copy is how a signal ends up supplied to one nav and not the
 * other, which is the drift `useOrderingCapabilities` exists to avoid.
 *
 * Everything is false/zero while the query loads, when the organisation
 * never went through onboarding (the common case by far), and when the
 * list is done. The gate fails CLOSED, so the row appears once there is
 * confirmed work rather than flashing up and being retracted.
 */
export const useOnboardingSetup = (orgId?: string): OnboardingSetupSignal => {
  const { data } = morpheusApi.useGetCustomerOnboardingQuery(orgId ?? '', {
    skip: !orgId,
  })

  const view = data?.data ?? null
  return {
    nav: view?.nav === true,
    outstanding: view?.outstanding_count ?? 0,
  }
}
